import { calculateDDay, cn } from "@/libs/utils";
import CommonBadge from "@/components/Common/Badge";

type Props = {
  targetDate: string | number;
};
export default function DDayBadge({ targetDate }: Props) {
  const dDay = calculateDDay(targetDate);
  return (
    <CommonBadge
      content={dDay < 0 ? "종료" : dDay === 0 ? "D-Day" : `D - ${dDay}`}
      className={cn({
        "bg-red text-white": dDay <= 3 && dDay >= 0,
        "bg-pink": dDay > 3 && dDay < 8,
        "bg-gray-B": dDay < 0,
      })}
    />
  );
}
